import { useTranslation } from "react-i18next";
import { Button, Dialog, Text } from "react-native-paper";
import DialogWrapper from "./DialogWrapper";

type Props = {
	visible: boolean;
	handleClose: () => void;
	title: string;
	message: string;
	onNavigateToPracticeTests: () => void;
};

export const OLXExamEligibilityDialog = ({
	visible,
	handleClose,
	title,
	message,
	onNavigateToPracticeTests,
}: Props) => {
	const { t } = useTranslation();

	return (
		<DialogWrapper visible={visible} handleClose={handleClose} maxWidth="xs">
			<Dialog.Icon icon="information-outline" />
			<Dialog.Title style={{ textAlign: "center" }}>{title}</Dialog.Title>
			<Dialog.Content>
				<Text variant="bodyMedium">{message}</Text>
			</Dialog.Content>
			<Dialog.Actions>
				<Button
					mode="contained"
					contentStyle={{
						paddingHorizontal: 8,
					}}
					onPress={() => {
						onNavigateToPracticeTests();
						handleClose();
					}}
				>
					{t("olxEligibility.goToPracticeTests")}
				</Button>
			</Dialog.Actions>
		</DialogWrapper>
	);
};
